import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	count: 0,
	options: {},
};

const loaderSlice = createSlice({
	name: "message",
	initialState,
	reducers: {
		showLoader: (state) => {
			state.count += 1;
		},
		hideLoader: (state) => {
			state.count -= 1;
		},
	},
});

export const { hideLoader, showLoader } = loaderSlice.actions;

export default loaderSlice.reducer;
